import router from '../router'

/**
 * 跳转登录
 */
export function logInByWechat(currentPath) {
    const baseUrl = window.location.origin
    const redirectUri = encodeURI(`http://m.xczim.com/wechat-login?redirect=${baseUrl}/wechat-login`)

    window.location = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx722a2cb8530f222f&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=${currentPath}#wechat_redirect`
}

// export function logIn(url) {
//     if (isWechat()) {
//         logInByWechat(url)
//     } else {
//         router.push({ name: 'logInSelection', query: { from: url } })
//     }
// }

export function isWechat() {
    let ua = navigator.userAgent.toLowerCase()

    return ua.match(/MicroMessenger/i) == "micromessenger"
}



// WEBPACK FOOTER //
// ./src/utils/utils.js